/* @jsx h */
import { defineComponent, h, computed } from "vue";
import { LemmonModal, QRCodeComponent, useLocalization } from "@lemmonhq/uikit";

export interface LoyaltyQRModalProps {
  customer: {
    id: string;
    email?: string;
    name?: string;
    anon?: boolean;
  };
  onClose: () => void;
}
//
export const LoyaltyQRModal = defineComponent<LoyaltyQRModalProps>({
  name: "LoyaltyQRModal",
  props: ["customer", "onClose"],
  setup(props) {
    const { t } = useLocalization();
    const loyaltyData = `lemmon-loyalty:${props.customer.id}`;

    const isRegistered = computed(() => {
      return "email" in props.customer && !props.customer.anon;
    });

    const displayName = computed(() => {
      if (isRegistered.value && props.customer.name) {
        return props.customer.name;
      }
      if (isRegistered.value && props.customer.email) {
        return props.customer.email.split("@")[0];
      }
      return t("customer.account.member");
    });

    return () => (
      <LemmonModal
        title={t("customer.account.loyalty_rewards_program")}
        onClose={props.onClose}
        renderButtons={() => null}
      >
        <div class="px-4 py-8 ">
          <div class="max-w-sm mx-auto">
            {/* Header */}

            {/* QR Code - Prominently Displayed */}
            <div class="mb-6">
              <div class="bg-white rounded-2xl p-6 shadow-2xl">
                <div class="w-full aspect-square max-w-[280px] mx-auto">
                  <QRCodeComponent url={loyaltyData} />
                </div>
              </div>
              {/* QR Glow Effect */}
              <div class="relative -mt-6 mx-auto w-64 h-6 bg-gradient-to-r from-blue-500/30 via-purple-500/30 to-blue-500/30 rounded-full blur-xl"></div>
            </div>

            {/* Scan Instructions */}
            <div class="bg-base-300 backdrop-blur-sm rounded-xl p-4 mb-6 border">
              <div class="flex items-start gap-3">
                <span class="material-symbols-outlined text-yellow-400 text-2xl flex-shrink-0">
                  qr_code_scanner
                </span>
                <div>
                  <h3 class=" font-bold text-sm mb-1">
                    {t("customer.account.how_to_use_loyalty_pass")}
                  </h3>
                  <p class="text-xs leading-relaxed">
                    {t("customer.account.loyalty_qr_copy")}
                  </p>
                </div>
              </div>
            </div>

            {/* Member Info */}
            <div class="bg-base-300 backdrop-blur-sm rounded-xl p-4 mb-6 border">
              <div class="flex items-center justify-between mb-3">
                <div>
                  <p class="text-xs uppercase tracking-wider mb-1">
                    {t("customer.account.member")}
                  </p>
                  <p class="font-bold text-sm">{displayName.value}</p>
                </div>
                <div class="text-right">
                  <p class="text-xs uppercase tracking-wider mb-1">
                    {t("customer.account.member_id")}
                  </p>
                  <p class="font-mono text-xs tracking-wider">
                    {props.customer.id.slice(-8).toUpperCase()}
                  </p>
                </div>
              </div>

              {/* Quick Benefits */}
              <div class="grid grid-cols-3 gap-2 pt-3 border-t ">
                <div class="text-center">
                  <span class="material-symbols-outlined text-green-400 text-lg block mb-1">
                    stars
                  </span>
                  <p class="text-xs">{t("customer.account.earn_points")}</p>
                </div>
                <div class="text-center">
                  <span class="material-symbols-outlined text-purple-400 text-lg block mb-1">
                    redeem
                  </span>
                  <p class="text-xs">{t("customer.account.get_rewards")}</p>
                </div>
                <div class="text-center">
                  <span class="material-symbols-outlined text-orange-400 text-lg block mb-1">
                    local_offer
                  </span>
                  <p class="text-xs">{t("customer.account.offers")}</p>
                </div>
              </div>
            </div>

            {/* Footer */}
            <div class="mt-6 text-center">
              <p class="text-xs">{t("customer.account.loyalty_valid_at")}</p>
            </div>
          </div>
        </div>
      </LemmonModal>
    );
  },
});
